import { Badges } from "./Badges";
import { Countdown } from "./Countdown";
import { List } from "./List";
import { PriceCallout } from "./PriceCallout";
import { ReducedPrice } from "./ReducedPrice";

export const PaywallCustomization = Object.assign(List, {
  Badges,
  Countdown,
  PriceCallout,
  ReducedPrice,
});
